import React from 'react';

import ErrorIcon from 'icons/ic-email-error.svg';
import OpenedIcon from 'icons/ic-email-opened.svg';
import ReceivedIcon from 'icons/ic-email-received.svg';
import SentIcon from 'icons/ic-email-sent.svg';
import { Trans, useTranslation } from 'react-i18next';

import Tooltip from 'components/application/Tooltip';

import { asFormattedDateTime } from 'components/helpers/dates';

export default function DispatchRow({ dispatch }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectActivity.components.DispatchRow',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const { email, status, statusUpdatedAt } = dispatch.attributes;

  const DispatchIcon = {
    bounced: ErrorIcon,
    created: SentIcon,
    deferred: SentIcon,
    delivered: ReceivedIcon,
    dropped: ErrorIcon,
    failed: ErrorIcon,
    opened: OpenedIcon,
    processed: SentIcon,
    spamreport: ErrorIcon,
  }[status];

  const tooltip = (() => {
    if (['bounced', 'dropped'].includes(status)) return i18nTShared('notSent');

    if (['created', 'processed'].includes(status)) {
      return i18nTShared('processing');
    }

    return i18nT(`${status}.tooltip`);
  })();

  return (
    <div className='handshq__cell-content--near-spaced tw-mt-2'>
      <Tooltip
        placement='top'
        tooltip={tooltip}
        trigger='hover'
        triggerProps={{ className: 'tooltip-trigger tw-flex' }}
      >
        <DispatchIcon height={16} width={24} />
      </Tooltip>
      <div className='tw-ml-2'>
        {['bounced', 'dropped'].includes(status) ?
          <Trans
            i18nKey='projects.didntReceiveEmail'
            ns='common'
            tOptions={{ interpolation: { escapeValue: false } }}
            values={{ email }}
          />
        : ['created', 'processed'].includes(status) ?
          <Trans
            i18nKey='projects.hasntReceivedEmail'
            ns='common'
            tOptions={{ interpolation: { escapeValue: false } }}
            values={{ email }}
          />
        : <Trans
            i18nKey={`projectActivity.components.DispatchRow.${status}.description`}
            ns='components'
            tOptions={{ interpolation: { escapeValue: false } }}
            values={{
              date:
                statusUpdatedAt &&
                asFormattedDateTime({ date: statusUpdatedAt }),
              email,
            }}
          />
        }
      </div>
    </div>
  );
}
